import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
import mmenu from 'mmenu-js';

document.addEventListener("DOMContentLoaded", () => {
    const menuEl = document.querySelector('#menu');
    const metaNav = document.querySelector('#meta-nav-mobil');
    const eyeAbleContainer = document.getElementById('eyeAble_container_ID');

    if (menuEl && metaNav) {
        let metanav = [];
        for (const child of metaNav.children) {
            metanav.push(child.outerHTML);
        }
        metanav.push('close');

        new Mmenu("#menu", {
            navbars: [
                {
                    position: "top",
                    titleLink: "anchor",
                    content: metanav
                }
            ],
            offCanvas: {
                slidingSubmenus: false,
                position: "left-front",
                theme: "light",
            }
        }, {
            classNames: {
                selected: "selected"
            }
        });

        menuEl.setAttribute('tabindex', '-1');

        const initPanels = menuEl.querySelectorAll('.mm-panel');
        initPanels.forEach(panel => {
            panel.setAttribute('tabindex', '-1');
        });

        menuEl.addEventListener('openPanel:after', (event) => {
            const panel = event.detail.panel;
            if (panel) {
                panel.setAttribute('tabindex', '-1');
            }

            const isRoot = panel && panel.id === 'mm-1';

            setTimeout(() => {
                const navbar = document.querySelector('.mm-navbars--top .mm-navbar');
                if (!navbar) return;

                const newsBtn = navbar.querySelector('.menu-meta.news');
                const closeBtn = navbar.querySelector('.mm-btn--close');

                let focusTarget = null;
                if (window.innerWidth < 1280 && newsBtn) {
                    focusTarget = newsBtn;
                } else if (closeBtn) {
                    focusTarget = closeBtn;
                } else {
                    focusTarget = navbar.querySelector('a, button');
                }

                if (focusTarget && typeof focusTarget.focus === 'function') {
                    const originalTabIndex = focusTarget.getAttribute('tabindex');
                    focusTarget.setAttribute('tabindex', '-1');
                    focusTarget.focus();

                    setTimeout(() => {
                        if (originalTabIndex === null) {
                            focusTarget.removeAttribute('tabindex');
                        } else {
                            focusTarget.setAttribute('tabindex', originalTabIndex);
                        }
                    }, 100);
                }
            }, isRoot ? 300 : 100);
        });

        menuEl.addEventListener('click', (e) => {
            const backBtn = e.target.closest('.mm-btn--prev');
            if (!backBtn) return;

            setTimeout(() => {
                const panelId = backBtn.getAttribute('href')?.substring(1);
                const targetPanel = document.getElementById(panelId);

                if (backBtn && typeof backBtn.focus === 'function') {
                    backBtn.setAttribute('tabindex', '-1');
                    backBtn.focus();

                    setTimeout(() => {
                        backBtn.removeAttribute('tabindex');
                    }, 100);
                } else if (targetPanel) {
                    targetPanel.setAttribute('tabindex', '-1');
                    targetPanel.focus();
                }
            }, 350);
        });

        menuEl.addEventListener('keydown', function (e) {
            if (e.key !== 'Tab') return;

            const panel = menuEl.querySelector('.mm-panel--opened');
            if (!panel) return;

            const panelItems = panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
            const navbar = document.querySelector('.mm-navbars--top .mm-navbar');
            if (panelItems.length === 0 || !navbar) return;

            const firstNavbarLink = navbar.querySelector('a.menu-meta.news');
            const closeButton = navbar.querySelector('a.mm-btn--close');
            const lastItem = panelItems[panelItems.length - 1];
            const firstItem = panelItems[0];

            const target = (window.innerWidth < 1280 && firstNavbarLink) ? firstNavbarLink : closeButton;

            const blocker = document.querySelector('.mm-wrapper__blocker');
            if (blocker) {
                blocker.setAttribute('tabindex', '-1');
                blocker.setAttribute('aria-hidden', 'true');
                blocker.addEventListener('focus', (e) => e.preventDefault());
            }

            if (!e.shiftKey && document.activeElement === lastItem && target) {
                e.preventDefault();
                target.focus();
            }

            if (e.shiftKey && document.activeElement === target) {
                e.preventDefault();
                lastItem.focus();
            }
        });

        const weglot = document.querySelector('.weglot-container.wg-default');
        const updateAccessibility = () => {
            const isMenuOpen = document.body.classList.contains('mm-wrapper--opened');

            if (weglot) {
                if (isMenuOpen) {
                    weglot.setAttribute('tabindex', '-1');
                    weglot.setAttribute('aria-hidden', 'true');
                } else {
                    weglot.removeAttribute('tabindex');
                    weglot.removeAttribute('aria-hidden');
                }
            }

            if (eyeAbleContainer) {
                if (isMenuOpen) {
                    eyeAbleContainer.setAttribute('aria-hidden', 'true');
                    eyeAbleContainer.setAttribute('inert', '');
                } else {
                    eyeAbleContainer.removeAttribute('aria-hidden');
                    eyeAbleContainer.removeAttribute('inert');
                }
            }
        };

        const observer = new MutationObserver(updateAccessibility);
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        updateAccessibility();
    }

    const blocker = document.querySelector('.mm-wrapper__blocker');
    if (blocker) {
        blocker.setAttribute('tabindex', '-1');
    }
});
